const Data = [
  {
    name: "Arka Ghosh",
    position: "TechOps Head",
    imageUrl: "/assets/images/members/GB26/ArkaGhosh.jpg",
    facebookLink: "https://www.facebook.com/share/16fGCnvDJY/",
    linkedinLink: "https://www.linkedin.com/in/arka-ghosh-2729b529a/",
    email: "arka.ghosh@gyws.org"
  },
  {
    name: "Amlesh Kumar",
    position: "TechOps Head",
    imageUrl: "/assets/images/members/Heads25/AmleshKumar.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: "amlesh.kumar@gyws.org"
  },
  {
    name: "Harsh Gupta",
    position: "TechOps Head",
    imageUrl: "/assets/images/members/Heads25/HarshGupta.png",
    facebookLink: "",
    linkedinLink: "",
    email: "harsh.gupta@gyws.org"
  }
];

export default Data;